import { useTranslations } from 'next-intl';
import React from 'react';

type FormContactLinksProps = {
    /** Form page namespace, e.g. `rent-a-cinema` — resolves `{namespace}.contact.phone`/`.email` translations. */
    namespace: string;
    phone?: string | null;
    phoneURI?: string | null;
    email?: string | null;
};

/**
 * "Questions? Call {phone}" style contact row shown on the OUR SERVICES form pages
 * (rent-a-cinema, kids-n-teens, birthday-at-the-cinema, reservation, buy-gift-cards).
 * Renders nothing when neither a phone nor an email could be resolved.
 */
const FormContactLinks: React.FC<FormContactLinksProps> = ({ namespace, phone, phoneURI, email }) => {
    const t = useTranslations();

    if (!phone && !email) {
        return null;
    }

    return (
        <div className="flex flex-col lg:flex-row justify-center items-center gap-4">
            {phone && (
                <div className="flex items-center space-x-2">
                    <span className="text-body-14 text-[rgba(var(--on-background-color-rgb),0.8)]">
                        {t(`${namespace}.contact.phone`)}:
                    </span>
                    <a
                        href={phoneURI ?? undefined}
                        className="text-body-14 hover:opacity-80 transition-opacity text-[var(--primary-color)]">
                        {phone}
                    </a>
                </div>
            )}
            {email && (
                <div className="flex items-center space-x-2">
                    <span className="text-body-14 text-[rgba(var(--on-background-color-rgb),0.8)]">
                        {t(`${namespace}.contact.email`)}:
                    </span>
                    <a
                        href={`mailto:${email}`}
                        className="text-body-14 hover:opacity-80 transition-opacity text-[var(--primary-color)]">
                        {email}
                    </a>
                </div>
            )}
        </div>
    );
};

export default FormContactLinks;
